import PropTypes from 'prop-types'
import { DealerSalesChannels } from '../../models/selfservice/dealer-sales-channels-enum'

/**
 * @typedef {Object} dealerPropType
 * @property {string} [city]            - The city of the dealers contact address
 * @property {string} [country]         - The country of the dealers contact address
 * @property {string} [csppStatus]      - The cspp status of the dealer
 * @property {string} [email]           - The email address of the dealer
 * @property {string} [federalState]    - The federal state of the dealers contact address
 * @property {boolean}[isCspReseller]   - Flag to indicate if a dealer is a CSP reseller
 * @property {string} [phone]           - The phone number of the dealer
 * @property {string} [resellerId]      - The identifier of the dealer
 * @property {string} [resellerName]    - The name of the dealer
 * @property {string} [salesChannel]    - The type of the sales channel
 * @property {string} [street]          - The street address of the dealer
 * @property {string} [zip]             - The ZIP of the dealers contact address
 */
export const dealerPropType = PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    csppStatus: PropTypes.string,
    email: PropTypes.string,
    federalState: PropTypes.string,
    isCspReseller: PropTypes.bool,
    phone: PropTypes.string,
    resellerId: PropTypes.string,
    resellerName: PropTypes.string,
    salesChannel: PropTypes.oneOf(Object.values(DealerSalesChannels)),
    street: PropTypes.string,
    zip: PropTypes.string
})
